module.exports = __webpack_public_path__ + "static/media/Fondoformulario.81430f56.jpg";